import React, { Component } from 'react'

import './iconaccordion.scss'

// Elements
import Icon from '../icon'
// import Grid from '../grid'

class IconAccordion extends Component {
  constructor (props) {
    super(props)

    this.state = {
    }

    this.renderIcon = this.renderIcon.bind(this)
  }

  getSize () {
    switch (this.props.size) {
      case 's':
        return 'accordion-2'
      default:
      case 'm':
        return 'accordion-3'
      case 'l':
        return 'accordion-4'
    }
  }

  renderIcon (iconObj, index) {
    if (typeof iconObj.icon === 'undefined' && typeof iconObj.customComponent === 'undefined') {
      console.error('IconAccordion icons must be an array of type \'{ icon: ..., ... }\' OR \'{ customComponent: ..., ... }\'')
    }
    const { icon, customComponent, noCircle, ...iconProps } = iconObj

    const count = this.props.icons.length
    let iconSize = this.props.size

    let classNames = ''
    if (!noCircle) {
      classNames = 'element-icon-accordion__icon--circle'

      switch (this.props.size) {
        case 's':
          iconSize = 't'
          classNames += ' size-small'
          break
        case 'm':
        default:
          iconSize = 's'
          classNames += ' size-medium'
          break
        case 'l':
          iconSize = 'm'
          classNames += ' size-large'
          break
      }
    }

    let component = null
    if (icon) {
      component = <Icon
        icon={icon}
        size={iconSize}
        injectSvg
        {...iconProps}
      />
    } else if (customComponent) {
      const Component = customComponent
      component = <Component size={iconSize} {...iconProps} />
    }

    return (
      <div className={classNames} style={{ zIndex: count - index }} key={index}>
        {component}
      </div>
    )
  }

  render () {
    return (
      <div className={'element-icon-accordion ' + this.getSize()}>
        {this.props.icons.map(this.renderIcon)}
      </div>
    )
  }
}

IconAccordion.defaultProps = {
  size: 'm'
}

export default IconAccordion



// WEBPACK FOOTER //
// ./src/app/shared/elements/iconAccordion/index.js